// extracted by mini-css-extract-plugin
export default {"button":"Button_button__29vHa","primary":"Button_primary__zVv0U","secondary":"Button_secondary__xfBUE","fluid":"Button_fluid__KRE9F","small":"Button_small__6FXPW"};